import dynamic from 'next/dynamic'
import classNames from 'classnames'
import Image from '@dustin-web/microsite-components/src/image'
import { getRelativeProductImageUrl } from '@dustin-web/microsite-components/src/utils/urls'

const Tooltip = dynamic(() => import('@dustin-web/microsite-components/src/tooltip'))

import './product-variant-image-selector.scss'

type Props = {
  index: number
  isSelected: boolean
  isUnavailable: boolean
  href: string
  unavailableTooltipText: string
  variantPrimaryImageId: string
  variantDisplayName: string
  variantColorName: string
  onButtonClick: () => void
}

const imageSize = { width: 60, height: 60 } as const

const ProductVariantImageSelector = ({
  href,
  isSelected,
  isUnavailable,
  unavailableTooltipText,
  variantPrimaryImageId,
  variantDisplayName,
  variantColorName,
  onButtonClick,
}: Props) => {
  const imageSrc = getRelativeProductImageUrl(
    variantPrimaryImageId,
    imageSize.width,
    imageSize.height,
    variantDisplayName ?? ''
  )

  const VariantButton = (
    <a
      href={href}
      role="radio"
      aria-checked={isSelected}
      aria-label={`${variantColorName}, ${variantDisplayName}`}
      aria-disabled={isUnavailable || undefined}
      onClickCapture={e => {
        e.preventDefault()
        e.stopPropagation()
        if (!isUnavailable) onButtonClick()
      }}
      className={classNames('product-variant-image-selector-button', {
        selected: isSelected,
        unavailable: isUnavailable,
      })}>
      <Image
        draggable={false}
        width={imageSize.width}
        height={imageSize.width}
        src={imageSrc}
        alt={variantDisplayName}
      />
    </a>
  )

  if (!isUnavailable) {
    return VariantButton
  }

  return (
    <Tooltip className="unavailable-tooltip" tooltipText={unavailableTooltipText}>
      {VariantButton}
    </Tooltip>
  )
}

export default ProductVariantImageSelector
